export type MenuVerticalItem = {
  id: number
  name: string
  hidden: boolean
  submenu: {
    name: string
    link: string
    hidden: boolean
  }[]
}

export const menuVerticalItems = [
  {
    id: 1,
    name: 'Main',
    hidden: false,
    submenu: [
      { name: 'Home', link: '/', hidden: false },
      { name: 'Auth', link: '/main/auth', hidden: false },
      { name: 'About', link: '/main/about', hidden: false },
      { name: 'Eyes', link: '/main/eyes', hidden: false },
      { name: 'Jan', link: '/main/jan', hidden: false },
      { name: 'MSW', link: '/main/msw', hidden: false },
      { name: 'Test', link: '/main/test', hidden: false },
    ],
  },
  {
    id: 2,
    name: 'SaaS',
    hidden: false,
    submenu: [
      { name: 'Pricing', link: '/saas/pricing', hidden: false },
      { name: 'Sign-in', link: '/saas/signin', hidden: false }, // @@TODO: Only when signed OUT
      { name: 'Sign-up', link: '/saas/signin/signup', hidden: false }, // @@TODO: Only when signed OUT
      {
        name: 'Forgot password',
        link: '/saas/signin/forgot_password',
        hidden: false,
      }, // @@TODO: Only when signed OUT
      { name: 'Sign-out', link: '/saas/signout', hidden: false }, // @@TODO: Only when signed IN
      {
        name: 'Update password',
        link: '/saas/signin/update_password',
        hidden: false,
      }, // @@TODO: Only when signed IN
      { name: 'Account', link: '/saas/account', hidden: false }, // @@TODO: Only when signed IN
    ],
  },
  {
    id: 3,
    name: 'Sales',
    hidden: false,
    submenu: [{ name: 'Pricing', link: '/sales/pricing', hidden: false }],
  },
  {
    id: 4,
    name: 'Dashboard',
    hidden: false,
    submenu: [
      { name: 'Profile', link: '/dashboard/profile', hidden: false },
      { name: 'Account', link: '/dashboard/account', hidden: false },
      {
        name: 'Subscription',
        link: '/dashboard/subscription',
        hidden: false,
      },
      { name: 'Billing', link: '/dashboard/billing', hidden: false },
      { name: 'Dummy', link: '/dashboard/account', hidden: false },
    ],
  },
  {
    id: 6,
    name: 'Employee (RQ)',
    hidden: false,
    submenu: [
      {
        name: 'Get employee',
        link: '/react-query/get-employee',
        hidden: false,
      },
      {
        name: 'Get employees',
        link: '/react-query/get-employees',
        hidden: false,
      },
      {
        name: 'Create employee',
        link: '/react-query/create-employee',
        hidden: false,
      },
      {
        name: 'Delete employee',
        link: '/react-query/delete-employee',
        hidden: false,
      },
      {
        name: 'Update employee (*)',
        link: '/react-query/update-employee',
        hidden: false,
      },
    ],
  },
  {
    id: 8,
    name: 'Employee (SWR)',
    hidden: false,
    submenu: [
      {
        name: 'Create employee',
        link: '/swr/create-employee',
        hidden: false,
      },
      {
        name: 'Delete employee (*)',
        link: '/swr/delete-employee',
        hidden: false,
      },
      {
        name: 'Update employee (*)',
        link: '/swr/update-employee',
        hidden: false,
      },
    ],
  },
  {
    id: 9,
    name: 'Other (SWR)',
    hidden: false,
    submenu: [
      {
        name: 'Optimistic UI',
        link: '/swr/todo-optimistic-ui',
        hidden: false,
      },
    ],
  },
  {
    id: 10,
    name: 'Other',
    hidden: false,
    submenu: [
      {
        name: 'TV Shows',
        link: '/other/shows',
        hidden: false,
      },
      {
        name: 'Employees (table)',
        link: '/other/employees',
        hidden: false,
      },
    ],
  },
  {
    id: 11,
    name: 'Profile (Auth0)',
    hidden: false,
    submenu: [
      {
        name: 'Profile (client)',
        link: '/profile/profile-client',
        hidden: false,
      },
      {
        name: 'Profile (ssr)',
        link: '/profile/profile-ssr',
        hidden: false,
      },
    ],
  },
  {
    id: 12,
    name: 'Sentry',
    hidden: false,
    submenu: [
      {
        name: 'sentry example',
        link: '/sentry/sentry-example-page',
        hidden: false,
      },
    ],
  },
]
